import { ShiftModalComponentMap, ShiftModalViewType } from 'modals/ShiftModal/ShiftModal.constants';
import { useURLParameters } from 'hooks';
import { createContext, FC, useContext, useEffect, useState } from 'react';
import { ModalRoutingService } from 'services/ModalRoutingService';

export type ShiftModalContextType = {
  isOpen: boolean;
  shift_id?: string;
  shiftModalActiveModalView: ShiftModalViewType;
};

export const ShiftModalUIContext = createContext({
  isOpen: false,
  shift_id: undefined as ShiftModalContextType['shift_id'],
  shiftModalActiveModalView: 'DetailView' as ShiftModalViewType,
});

export const shiftModalRoutingService = new ModalRoutingService(
  'shiftModal',
  'DetailView',
  () => ShiftModalComponentMap,
  { shiftModalShiftId: 'string' },
  ['TeamMemberUnavailableView', 'ShiftUnavailableView'],
);

export const ShiftModalUIProvider: FC = ({ children }) => {
  const [{ shiftModalShiftId, shiftModalActiveModalView = 'DetailView' }, { removeParam }] =
    useURLParameters<{
      shiftModalShiftId?: string;
      shiftModalActiveModalView: ShiftModalViewType;
    }>();

  const [lastShiftId, setLastShiftId] = useState<string | undefined>(undefined);

  const shift_id = shiftModalShiftId || undefined;

  useEffect(() => {
    if (shift_id) setLastShiftId(shift_id);
  }, [shift_id]);

  useEffect(() => {
    if (window.j360) window.j360.shiftModalRoutingService = shiftModalRoutingService;
    if (!Object.keys(ShiftModalComponentMap).includes(shiftModalActiveModalView)) {
      removeParam(['shiftModalActiveModalView', 'shiftModalShiftId', 'shiftModalCommunityId']);
    }
    if (!shift_id && shiftModalActiveModalView) {
      removeParam('shiftModalActiveModalView');
    }
  }, [shiftModalActiveModalView, removeParam, shift_id]);

  return (
    <ShiftModalUIContext.Provider
      value={{
        isOpen: !!shift_id,
        shift_id: shift_id || lastShiftId,
        shiftModalActiveModalView,
      }}
    >
      {children}
    </ShiftModalUIContext.Provider>
  );
};

export const useShiftModalUIContext = (): ShiftModalContextType => useContext(ShiftModalUIContext);
